const genericUrl = process.env.REACT_APP_API_URL;

export async function GetJutgeUsuariIdJavamonsNota(idUser: string) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/usuaris/${idUser}/javamons/nota`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            const json = await response.json();
            return json;
        } else {
            return [];
        }
    } catch (e) {
        console.error(e);
        return [];
    }
}
